/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from "react";

import styled from "styled-components";

import {WealthyEnv} from "helpers";

const downArrow = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-dropdown-arrow.svg`;

// TODO: Make dropdown component as common and attach prop types.

const Calculator = ({
  professionRef,
  productsRef,
  clientsRef,
  clientNumbersMap,
  productsMap,
  productResultMap,
  professionOptions,
  setShowClientDropdown,
  showClientDropdown,
  setShowProfessionDropdown,
  showProfessionDropdown,
  setSelectedProfession,
  selectedProfession,
  selectedClientsValue,
  setSelectedClientsValue,
  setSelectedProduct,
  selectedProduct,
  setShowProductDropdown,
  showProductDropdown,
  result,
  setResult
}) => {
  return (
    <CalculatorWrapper id="wealthcalculator">
      <TextDropdownContainer>
        <LineWrapper>
          <Text>You as a&nbsp;<div
            className="dropdown-item"
            id={`selected-profession-${selectedProfession}`}
            ref={professionRef}
            onClick={() => setShowProfessionDropdown(!showProfessionDropdown)}
          >
            {selectedProfession}&nbsp;
            <DropdownContainer>
              <DropdownImage>
                <img alt="dropdown-icon" loading="lazy" src={downArrow} />
              </DropdownImage>
              {
                showProfessionDropdown && (
                  <ul className="dropdown-menu">
                    {
                      professionOptions.map((eachOption) => {
                        return (
                          <li
                            className="dropdown-menu__item"
                            key={eachOption}
                            onClick={() => {
                              setSelectedProfession(eachOption);
                              setShowProfessionDropdown(!showProfessionDropdown);
                            }}
                          >
                            {eachOption}
                          </li>
                        );
                      })
                    }
                  </ul>
                )
              }
            </DropdownContainer>
          </div>
          </Text>

          <Text className="for-mobile">
            &nbsp;&nbsp;&nbsp;with&nbsp;<div
              className="dropdown-item clients-dropdown"

              id={`selected-clients-value-${selectedClientsValue}`}
              ref={clientsRef}
              onClick={() => setShowClientDropdown(!showClientDropdown)}
            >
              {clientNumbersMap[selectedClientsValue]}&nbsp;
              <DropdownContainer>
                <DropdownImage>
                  <img alt="dropdown-icon" loading="lazy" src={downArrow} />
                </DropdownImage>
                {
                  showClientDropdown && (
                    <ul className="dropdown-menu">
                      {
                        Object.keys(clientNumbersMap).map((keyName, keyIndex) => {
                          return (
                            <li
                              className="dropdown-menu__item"
                              key={keyIndex}
                              onClick={() => {
                                setSelectedClientsValue(keyName);
                                setShowClientDropdown(!showClientDropdown);
                              }}
                            >
                              {clientNumbersMap[keyName]}
                            </li>
                          );
                        })
                      }
                    </ul>
                  )
                }
              </DropdownContainer>


            </div>&nbsp;
          </Text>
        </LineWrapper>



        <Text>selling&nbsp;<div
          className="dropdown-item-product"
          id={`selected-product-${selectedProduct}`}
          ref={productsRef}
          onClick={() => setShowProductDropdown(!showProductDropdown)}
        >
          {productsMap[selectedProduct]}&nbsp;

          <DropdownContainer>
            <DropdownImage>
              <img alt="dropdown-icon" loading="lazy" src={downArrow} />
            </DropdownImage>
            {
              showProductDropdown && (
                <ul className="dropdown-menu">
                  {
                    Object.keys(productsMap).map((keyName, keyIndex) => {
                      return (
                        <li
                          className="dropdown-menu__item"
                          key={keyIndex}
                          onClick={() => {
                            setSelectedProduct(keyName);
                            setShowProductDropdown(!showProductDropdown);
                          }}
                        >
                          {productsMap[keyName]}
                        </li>
                      );
                    })
                  }
                </ul>
              )
            }
          </DropdownContainer>

        </div></Text>
      </TextDropdownContainer>


      <CalculatedContent>
        can earn up to&nbsp;<span className="calculated-value" id="result" >
        ₹&nbsp;{result}/month
        </span>
      </CalculatedContent>
      <Description>
        Our top Partners earn upto ₹ 3L/month with hassle-free, automated monthly payouts.
      </Description>
    </CalculatorWrapper>
  );
};

const LineWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 0;
    justify-content: flex-start;
  }
`;

const CalculatorWrapper = styled.div`
  padding: 10rem 0;
  background-color: #f9f9f9;

  .drop-item-fade-in {
    opacity: 0;
  }

  .drop-item-in-view {
    opacity: 1;
    transform: translateY(0);
    transition: all 400ms cubic-bezier(0.46,0.03,0.52,0.96);
  }

  @media (max-width: 768px) {
    padding: 10rem 2rem;
  }
`;

const DropdownImage = styled.span`
  width: 5rem;
  cursor: pointer;
  @media (max-width: 768px) {
    >img {
      width: 2.4rem;
      vertical-align: middle;
    }
  }
`;

const DropdownContainer = styled.span`
  .dropdown-menu {
    display: block;
    top: 7rem;
    width: max-content;
    border-radius: 16px;
    box-shadow: 10px 10px 60px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    padding: 1rem 4rem 1rem 2rem;
  }
  .dropdown-menu .dropdown-menu__item {
    font-size: 2.4rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.33;
    letter-spacing: normal;
    text-align: left;
    color: #000;
    padding-left: 1rem;
  }

  .dropdown-menu::after {
    display: none !important;
  }

  .dropdown-menu::before {
    content: "";
    position: absolute;
    left: calc(50% - 10px);
    margin-top: -7px;
    width: 0;
    height: 0;
    border: 7px solid transparent;
    z-index: -1;
    transform: rotate(45deg);
  }

  @media (max-width: 768px) {
    .dropdown-menu {
      top: 5rem;
      left: -25%;
      width: max-content;
    }

    .dropdown-menu .dropdown-menu__item {
      font-size: 2rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.33;
      letter-spacing: normal;
      text-align: left;
      color: #000;
      padding-left: 1rem;
    }

  }

`;

const TextDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Text = styled.div`
  font-family: MavenPro;
  font-size: 3.6rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1c1c1c;
  display: flex;
  justify-content: center;

  .dropdown-item, .dropdown-item-product {
    text-decoration: underline;
    color: #6725f4;
    z-index: 2;

    :hover {
      cursor: pointer;
    }
  }

  .dropdown-item-product {
    z-index: 0;
  }

  @media (max-width: 768px) {
    font-size: 2.4rem;
    margin-bottom: 2rem;

    .dropdown-item.clients-dropdown {
      z-index: 1;
    }
  }
`;

const CalculatedContent = styled.h2`
  margin-top: 4rem;
  font-family: MavenPro;
  font-size: 3.6rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #7e7e7e;
  display: flex;
  justify-content: center;

  .calculated-value {
    font-weight: bold;
    color: #1c1c1c;
  }
  @media (max-width: 768px) {
    font-size: 2.4rem;
    margin-top: 0rem;
  }
`;

const Description = styled.p`
  margin-top: 5rem;
  font-family: MavenPro;
  font-size: 1.8rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1c1c1c;

  @media (max-width: 768px) {
    margin-top: 5rem;
    font-size: 1.8rem;
    font-weight: 600;
  }
`;

export default Calculator;
